// import axios from 'axios';
// import { useEffect, useState } from 'react';

// axios.defaults.baseURL=process.env.REACT_APP_SERVER_DOMAIN


// //custom hook
// export default function useFetch(query){
//    const [getData, setData]= useState({isLoding:false,apiData:undefined,status:null,serverError:null});

//    useEffect(()=>{
//     if(!query) return;
//     const fetchData=async()=>{
//         try{
//             setData(prev=>({...prev,isLoading:true}));

//             const {data,status}=await axios.get(`/api/${query}`);
//             if(status===201){
//                 setData(prev=>({...prev,isLoading:false}));
//                 setData(prev=>({...prev,apiData:data,status:status}));
//             }
//             setData(prev=>({...prev,isLoading:false}));
//         }catch(error){
//             setData(prev=>({...prev,isLoading:false,serverError:error}));
//             // setData(prev=>({...prev,isLoading:false,}));
//         }
//     };
//     fetchData()
//    },[query]);

//    return [getData,setData];

// }
import axios from 'axios';
import { useEffect, useState } from 'react';
import {getUsername} from '../Helpers/helper'

axios.defaults.baseURL = process.env.REACT_APP_SERVER_DOMAIN;

export default function useFetch(query) {
    const [getData, setData] = useState({
        isLoading: false,
        apiData: undefined,
        status: null,
        serverError: null
    });

    useEffect(() => {
        
    
        const fetchData = async () => {
            setData(prev => ({ ...prev, isLoading: true }));

        // const {username}= !query ?await getUsername():'';
        const {username} = !query ? await getUsername() : '';
 try {
  //  const { data, status } = await axios.get(`/api/${query}`);
  const { data, status } = !query ? await axios.get(`api/user/${username}`):await axios.get(`/api/${query}`);
  // console.log("Fetch successful:", status, data); // <-- this should run if the fetch succeeds

  if (status === 200 || status === 201) {
    setData({
      isLoading: false,
      apiData: data,
      status: status,
      serverError: null
    });
  } else {
    // console.warn("Unexpected response status:", status);
    setData(prev => ({ ...prev, isLoading: false }));
  }
} catch (error) {
  // console.error("❌ Fetch error:", error); 
  setData({
    isLoading: false,
    apiData: undefined,
    status: null,
    serverError: error
  });
}

        };

        fetchData();
    }, [query]);

    return [getData, setData];
}
